import { createMergeReducer } from '../utils/reducer'
import * as WpsTypes from 'DVWebNodeWpsRuntime'

export type PageContext = WpsTypes.atv.wps.PageContextModelProps

export const reducer = createMergeReducer(
  t => t.pageContext,
  {} as PageContext
)

